import React from "react";

export const EatIcon = ({
  width = 16.339,
  height = 25.838,
  fill = "#fff",
  className = "",
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16.339 25.838"
    >
      <g id="eat" transform="translate(-1097 -746.992)">
        <g id="eat-2" data-name="eat" transform="translate(1097 746.992)">
          <path
            id="Path_13156"
            data-name="Path 13156"
            d="M69.438,12.924q0,5.708,0,11.415c0,1.167-.294,1.5-1.3,1.5-.972,0-1.325-.392-1.327-1.508,0-3.213-.008-6.426.006-9.639a1.071,1.071,0,0,0-.6-1.136,2.293,2.293,0,0,1-1.278-2.3A38.593,38.593,0,0,1,66.7,1.93,6.893,6.893,0,0,1,67.448.519,1.147,1.147,0,0,1,68.866.078c.549.165.563.619.562,1.093q-.01,5.876,0,11.753h.014"
            transform="translate(-53.099 0)"
            fill={fill}
          />
          <path
            id="Path_13155"
            data-name="Path 13155"
            d="M2.359,19.694c0-1.889-.014-3.778.009-5.667a1.068,1.068,0,0,0-.559-1.1A3.394,3.394,0,0,1,.005,9.57C.1,7.4.03,5.23.03,3.059c0-.2-.014-.4.005-.592C.09,1.9.117,1.23.887,1.248c.734.017.725.647.725,1.2q0,2.96,0,5.921c0,.46-.055.946.621.97.7.024.64-.463.639-.926q-.005-2.918,0-5.836c0-.225-.065-.505.042-.663.184-.27.458-.595.738-.643.183-.032.536.346.644.61a2.985,2.985,0,0,1,.113,1.083c.01,1.833,0,3.665.006,5.5,0,.436-.01.873.621.881.649.008.7-.4.7-.9-.009-1.917,0-3.834,0-5.752a1.676,1.676,0,0,1,.039-.749c.158-.279.426-.615.7-.671.194-.04.575.295.692.546A2.643,2.643,0,0,1,7.3,2.89c0,2.284-.072,4.569,0,6.85A3.188,3.188,0,0,1,5.63,12.822a1.284,1.284,0,0,0-.659,1.308c.024,3.778.015,7.556.01,11.334,0,1.072-.377,1.433-1.415,1.409-.848-.02-1.2-.372-1.2-1.259-.009-1.974,0-3.947,0-5.921"
            transform="translate(0 -1.036)"
            fill={fill}
          />
        </g>
      </g>
    </svg>
  );
};
